module.exports = __webpack_public_path__ + "fonts/NotoSans-Regular.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/Noto_Sans/NotoSans-Regular.ttf
// module id = 3445
// module chunks = 0